import { useState, useRef, useEffect } from 'react';

interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}

export default function FAQItem({ question, answer, isOpen, onToggle }: FAQItemProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [answer]);

  return (
    <div className="border border-background-200/70 rounded-lg overflow-hidden transition-all duration-300 hover:border-background-300/60">
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between px-5 py-4 text-left bg-background-50 hover:bg-background-100/70 transition-colors duration-200 cursor-pointer"
      >
        <span className="text-foreground-800 font-medium pr-4">{question}</span>
        <span className={`flex-shrink-0 w-6 h-6 flex items-center justify-center transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}>
          <i className="ri-arrow-down-s-line text-foreground-500"></i>
        </span>
      </button>
      <div
        className="overflow-hidden transition-all duration-300 ease-in-out"
        style={{ maxHeight: isOpen ? `${contentHeight + 32}px` : '0px' }}
      >
        <div ref={contentRef} className="px-5 pb-4 text-foreground-600 text-sm leading-relaxed">
          {answer}
        </div>
      </div>
    </div>
  );
}